import { useEffect, useState } from "react";
import { Bike } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Required courier picker shown in the new-order form.
 * Renders a horizontally scrolling row of courier chips for fast mobile selection.
 * On a single tap the chip becomes the active selection.
 */
export function CourierSelect({ value, onChange, testIdPrefix = "claim-pick" }) {
  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    api.get("/users/couriers").then(({ data }) => setCouriers(data)).catch(() => {});
  }, []);

  if (couriers.length === 0) {
    return (
      <div className="border-2 border-dashed border-zinc-300 bg-zinc-50 p-3 text-center font-mono text-[11px] uppercase tracking-wider text-zinc-500">
        Aktif kurye yok — yönetici eklemeli
      </div>
    );
  }

  return (
    <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" data-testid={`${testIdPrefix}-list`}>
      {couriers.map((c) => {
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            data-testid={`${testIdPrefix}-${c.id}`}
            onClick={() => onChange?.(c.id)}
            className={`shrink-0 flex items-center gap-2 px-3 py-2.5 border-2 transition-colors ${
              active
                ? "bg-amber-500 border-amber-700 text-zinc-950"
                : "bg-white border-zinc-200 text-zinc-700 hover:border-zinc-950"
            }`}
          >
            <Bike size={13} strokeWidth={2.5} />
            <span className="text-sm font-bold whitespace-nowrap">{c.display_name}</span>
          </button>
        );
      })}
    </div>
  );
}
